const columns = (renderCell, renderJsonField) => [
  {
    field: 'timestamp',
    headerName: 'Timestamp',
    width: 250,
    hide: false,
    renderCell,
    headerAlign: 'center'
  },
  {
    field: 'userEmail',
    headerName: 'Email',
    width: 300,
    renderCell,
    headerAlign: 'center'
  },
  {
    field: 'caller',
    headerName: 'Caller',
    width: 300,
    renderCell: renderJsonField,
    headerAlign: 'center',
    align: 'left',
    sortable: false
  },
  {
    field: 'payload',
    headerName: 'Payload',
    width: 300,
    renderCell: renderJsonField,
    headerAlign: 'center',
    align: 'left',
    sortable: false
  },
];

export default columns;
